import styled from 'styled-components';

export const Container = styled.div`
  top: 56px;
  height: calc(100vh - 56px);
  display: flex;
  flex-direction: column;

  form {
    flex: 1;
    min-height: 0;
    overflow-y: auto;
    overflow-x: hidden;
    padding-bottom: 8px;

    &::-webkit-scrollbar {
      width: 0;
      height: 0;
    }
    scrollbar-width: none;
  }

  .toggle-wrapper {
    background: ${(props) => props.theme.$gray300};
  }

  .btn-ia {
    border: 1px solid transparent;
    padding: 8px 12px;
    font-size: 16px;
    background: linear-gradient(90deg, #007bff, #009f79) padding-box,
      linear-gradient(90deg, #007bff, #009f79) border-box;
  }

  .bg-light {
    background: ${(props) => props.theme.$gray300} !important;
  }

  .toggle-btn {
    background: transparent;
    font-weight: 600;
    color: #21354a !important;
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .toggle-btn.active {
    background: ${(props) => props.theme.$white};
    color: #21354a;
  }

  label {
    color: #000;
    font-size: 14px;
    font-style: normal;
    font-weight: 400;
    line-height: normal;
  }

  .filter-actions {
    position: sticky;
    bottom: 0;
    background: ${(props) => props.theme.$white};
    padding: 16px 8px 12px;
    box-shadow: 0 -4px 8px rgba(0, 0, 0, 0.04);
    border-top: 1px solid ${(props) => props.theme.$gray300};

    .save-row {
      display: flex;
      align-items: center;
      justify-content: space-between;
      gap: 12px;
      margin-bottom: 12px;
      white-space: nowrap;
    }

    .custom-control {
      padding-left: 0;
      margin-bottom: 0;
      width: auto;
    }
  }

  .filter-active {
    pointer-events: none;
    opacity: 60%;
  }

  .date-range-full {
    .DateRangePicker {
      width: 100%;
    }

    .DateRangePickerInput {
      width: 100%;
      display: flex;
      align-items: center;
      white-space: nowrap;
    }

    .DateRangePickerInput_arrow {
      padding: 0 8px;
    }

    .DateInput {
      width: 50%;
    }

    .DateInput_input {
      width: 100%;
      padding: 8px 10px;
      height: auto;
    }
  }
`;
